import { render } from "./BlockModule.vue?vue&type=template&id=7f98178f"
import script from "./BlockModule.vue?vue&type=script&lang=js"
export * from "./BlockModule.vue?vue&type=script&lang=js"

import "./BlockModule.vue?vue&type=style&index=0&id=7f98178f&lang=scss"

import exportComponent from "/home/jenkins/workspace/DeputyApp_web-hr_202604161159/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__